import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';

interface IServerResponse {
  status: any;
  message: string;
  result: any;
  count?: number;
}

const API_URL = environment.API_URL + '/admin';

@Injectable()
export class GmarketService {
  constructor(private http: HttpClient, private https: Http) { }

  // ➕ Create Province
  createProvince(formData: any): Observable<IServerResponse> {
    return this.https.post(`${API_URL}/province`, formData).pipe(
      map(res => res.json())
    );
  }

  // 📋 Get Provinces (with pagination)
  getProvinces(page: number): Observable<IServerResponse> {
    return this.https.get(`${API_URL}/province?page=${page}`).pipe(
      map(res => res.json())
    );
  }

  // 🔎 Search Provinces
  searchProvinces(query: string): Observable<IServerResponse> {
    return this.https.get(`${API_URL}/searchprovince?q=${query}`).pipe(
      map(res => res.json())
    );
  }

  // ✏️ Update Province
  updateProvince(formData: any): Observable<IServerResponse> {
    return this.https.put(`${API_URL}/province`, formData).pipe(
      map(res => res.json())
    );
  }

  // ❌ Delete Province
  deleteProvince(id: string): Observable<IServerResponse> {
    return this.https.delete(`${API_URL}/province/${id}`).pipe(
      map(res => res.json())
    );
  }

  getCategories(page = 1, search = '') {
    if (search) {
      return this.https.get(`${API_URL}/categories/search?q=${search}&page=${page}`).pipe(
        map(res => res.json())
      );
    }
    return this.https.get(`${API_URL}/categories?page=${page}`).pipe(
      map(res => res.json())
    );;
  }

  createCategory(data: { name: string, parent?: string }) {
    return this.https.post(API_URL + '/category', data).pipe(
      map(res => res.json())
    );
  }
  getCategoryById(id: any) {
    return this.https.get(API_URL + '/category/' + id).pipe(
      map(res => res.json())
    );
  }
  editCategory(formData: any) {
    return this.https.put(API_URL + '/category', formData).pipe(
      map(res => res.json())
    );
  }
  deleteCategory(id: any) {
    return this.https.delete(API_URL + '/category/' + id).pipe(
      map(res => res.json())
    );
  }
  getSubcategories(parentId: string, page = 1, search = '') {
    if (search) {
      return this.https.get(`${API_URL}/category/${parentId}/subcategories/search?q=${search}&page=${page}`).pipe(
        map(res => res.json())
      );
    }
    return this.https.get(`${API_URL}/category/${parentId}/subcategories?page=${page}`).pipe(
      map(res => res.json())
    );
  }

  getAttributes(page = 1, search = '') {
    if (search) {
      return this.https.get(`${API_URL}/attributes?search=${search}&page=${page}`).pipe(
        map(res => res.json())
      );
    }
    return this.https.get(`${API_URL}/attributes?page=${page}`).pipe(
      map(res => res.json())
    );
  }
  createAttribute(formData: any) {
    return this.https.post(API_URL + '/attribute', formData).pipe(
      map(res => res.json())
    );
  }
  getAttributeById(id: any) {
    return this.https.get(API_URL + '/attribute/' + id).pipe(
      map(res => res.json())
    );
  }
  updateAttribute(formData: any) {
    return this.https.put(API_URL + '/attribute', formData).pipe(
      map(res => res.json())
    );
  }
  deleteAttribute(id: any) {
    return this.https.delete(API_URL + '/attribute/' + id).pipe(
      map(res => res.json())
    );
  }
  getAllGmarketUsers(page: number) {
    return this.https.get(API_URL + '/getallgmarketuser?page=' + page).pipe(
      map(res => res.json())
    );
  }
  getUsersBySearch(page: number, search: string) {
    return this.https.get(API_URL + '/getgmarketusersearch?page=' + page + '&search=' + search).pipe(
      map(res => res.json())
    );
  }
  getgUsersById(id: any) {
    return this.https.get(API_URL + '/getgmarketuserByid/' + id).pipe(
      map(res => res.json())
    );
  }
  getAllProducts(page: number, search: string = '', category: string = '') {
    let url = API_URL + '/getAllProducts?page=' + page + '&search=' + search;
    if (category) {
      url += '&category=' + category;
    }
    return this.https.get(url).pipe(map(res => res.json()));
  }
  getProductDetails(id: any) {
    return this.https.get(API_URL + '/getproductdetails/' + id).pipe(map(res => res.json()));
  }
  makeGmarketAgent(payload: any) {
    return this.https.post(API_URL + '/makegmarketAgent', payload).pipe(
      map(res => res.json())
    );
  }

  getAllOrders(page: number, search: string = '', status: string = '') {
    let url = API_URL + '/getallorders?page=' + page + '&search=' + search;
    if (status) {
      url += '&status=' + status;
    }
    return this.https.get(url).pipe(map(res => res.json()));
  }
  getOrder(id: any) {
    return this.https.get(API_URL + '/getorderdetails/' +id).pipe(map(res => res.json()));
  }
  approveOrder(payload: any) {
    return this.https.put(API_URL + '/updateorderstatus/' , payload).pipe(map(res => res.json()));
  }

  // Claim Request APIs
  getPendingClaims(page: number, search: string = '') {
    return this.https.get(API_URL + '/pending-claims?page=' + page + '&search=' + search).pipe(map(res => res.json()));
  }

  processClaim(payload: any) {
    return this.https.post(API_URL + '/process-claim', payload).pipe(map(res => res.json()));
  }

  // Get Seller Statistics API
  getSellerStatistics(sellerId: string, period: string = 'all', startDate: string = '', endDate: string = '') {
    let url = API_URL + '/getsellerstatistics?seller_id=' + sellerId + '&period=' + period;
    if (startDate) {
      url += '&startDate=' + startDate;
    }
    if (endDate) {
      url += '&endDate=' + endDate;
    }
    return this.https.get(url).pipe(map(res => res.json()));
  }

  // Approve / Unapprove Product by Admin
  verifyProduct(product_id: string, approve: boolean) {
    const payload = { product_id, approve } as any;
    return this.https.post(API_URL + '/product/verify', payload).pipe(map(res => res.json()));
  }
}
